import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "projects/ert/src/environments/environment";
import { ERTEmergencyResponse } from "../../interfaces/emergencyresponse/emergencyresponse";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
const apiHost = environment.apiUrl;

@Injectable({
  providedIn: "root",
})
export class ERTEmergencyResponseService {
  newERTEmergencyResponse: ERTEmergencyResponse;
  addEmergencyResponseForm: FormGroup;

  emergencyResponseId: string;
  dateTimeIncidentOccured: string;
  dateTimeIncidentCleared: string;
  commanderName: string;
  currentEmergencyResponse: ERTEmergencyResponse;

  constructor(private httpClient: HttpClient, private fb: FormBuilder) {
    this.addEmergencyResponseForm = this.fb.group({
      dateAndTimeIncidentOccurred: ["", Validators.required],
      dateAndTimeIncidentCleared: ["", Validators.required],
      incidentCommander: ["", Validators.required],
      description: [""],
      fire: [false],
      rescue: [false],
      hazmat: [false],
      leak: [false],
      odor: [false],
      ertCallOut: [false],
      other: [false],
      otherDescription: [""],
      medical: [false],
      reasonForResponse: [""],
      tactics: [""],
      results: [""],
      responders: [""],
      comments: [""],
    });
  }

  public setERTEmergencyResponse(data: ERTEmergencyResponse) {
    this.newERTEmergencyResponse = { ...this.newERTEmergencyResponse, ...data };
  }

  public getAllERTEmergencyResponses(facilityId: number) {
    return this.httpClient.get<ERTEmergencyResponse[]>(
      `${apiHost}/emergencyResponses/${facilityId}`
    );
  }

  public getERTEmergencyResponseById(ertEmergencyResponseId: number, loggedInUserFacilityId: number) {
    return this.httpClient.get<ERTEmergencyResponse>(
      `${apiHost}/emergencyResponse/${ertEmergencyResponseId}?loggedInUserFacilityId=${loggedInUserFacilityId}`
    );
  }

  public addERTEmergencyResponse() {
    return this.httpClient.post(
      `${apiHost}/emergencyResponse`,
      this.newERTEmergencyResponse
    );
  }

  public updateERTEmergencyResponse(
    ertEmergencyResponse: ERTEmergencyResponse, loggedInUserFacilityId: number
  ) {
    return this.httpClient.put(
      `${apiHost}/emergencyResponse/${ertEmergencyResponse.id}?loggedInUserFacilityId=${loggedInUserFacilityId}`,
      ertEmergencyResponse
    );
  }

  public deleteERTEmergencyResponse(ertEmergencyResponseId: number, loggedInUserFacilityId: number) {
    return this.httpClient.delete(
      `${apiHost}/emergencyResponse/${ertEmergencyResponseId}?loggedInUserFacilityId=${loggedInUserFacilityId}`
    );
  }

  public validateNewEmergencyResponseStep1(formGroup: FormGroup): string[] {
    const validationMessages: string[] = [];
    if (!formGroup.get("dateAndTimeIncidentOccurred")?.value) {
      validationMessages.push(
        "Date and Time when Incident Occurred is required"
      );
    }
    if (!formGroup.get("dateAndTimeIncidentCleared")?.value) {
      validationMessages.push(
        "Date and Time when Incident Cleared is required"
      );
    }
    if (!formGroup.get("incidentCommander")?.value) {
      validationMessages.push("Incident Commander is required");
    }
    return validationMessages;
  }

  formatDate(input: string): string {
    const date = new Date(input);

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    let hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = Number(hours) >= 12 ? "PM" : "AM";
    hours = (Number(hours) % 12).toString().padStart(2, "0");
    hours = Number(hours) ? hours : "12";
    const strTime = `${hours}:${minutes} ${ampm}`;

    return `${month}/${day}/${year} ${strTime}`;
  }

  printEmergencyResponseForm(id: string, loggedInUserFacilityId: number) {
    this.getERTEmergencyResponseById(Number(id), loggedInUserFacilityId).subscribe((data) => {
      this.currentEmergencyResponse = data;
      this.commanderName = data.incidentCommander.fullName;
      this.dateTimeIncidentOccured = this.formatDate(
        data.dateTimeIncidentOccured.slice(0, 16)
      );
      this.dateTimeIncidentCleared = this.formatDate(
        data.dateTimeIncidentCleared.slice(0, 16)
      );

      const printWindow = window.open("", "Emergency Response Form");

      if (printWindow) {
        printWindow.document.write(
          `
<!DOCTYPE html>
<html>

<head>
    <title style="text-align: center">ERT Emergency Response</title>
    <meta charset="utf-8">
</head>

<body style="font-family: Arial, sans-serif; font-size: 12px; padding: 20px; margin: 0;">
    <main>
        <div style="background-color: white; padding: 20px;">
            <div style="background-color: white; overflow-y: auto; padding: 20px;">
                <h2 style="text-align: center; padding-top: 10px; padding-bottom: 20px; margin-bottom: 10px;">Emergency Response</h2>

                <div style="display: flex; margin-bottom: 10px;">
                    <div style="width: 30%; font-weight: bold; padding-top: 5px;">Date/Time Incident Occurred</div>
                    <div style="width: 25%; border: 1px solid black; padding: 5px;">${
                      this.dateTimeIncidentOccured ?? ""
                    }</div>
                    <div style="width: 25%; font-weight: bold; padding-top: 5px; padding-right: 4px; text-align: right;">Date/Time Cleared</div>
                    <div style="width: 20%; border: 1px solid black; padding: 5px;">${
                      this.dateTimeIncidentCleared ?? ""
                    }</div>
                </div>

                <div style="display: flex; margin-bottom: 10px;">
                    <div style="width: 30%; font-weight: bold; padding-top: 5px;">Incident Commander</div>
                    <div style="width: 25%; border: 1px solid black; padding: 5px;">${
                      this.commanderName ?? ""
                    }</div>
                    <div style="width: 25%; font-weight: bold;"></div>
                    <div style="width: 20%; padding: 5px;"></div>
                </div>

                <div style="display: flex; margin-bottom: 10px;">
                    <div style="width: 15%; font-weight: bold; padding-top: 5px;">Rescue</div>
                    <div style="width: 2%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.currentEmergencyResponse?.isRescue ? "X" : " "
                    }</div>
                    <div style="width: 8%;"></div>
                    <div style="width: 15%; font-weight: bold; padding-top: 5px;">Leak</div>
                    <div style="width: 2%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.currentEmergencyResponse?.isLeak ? "X" : " "
                    }</div>
                    <div style="width: 8%;"></div>
                    <div style="width: 15%; font-weight: bold; padding-top: 5px;">Hazmat</div>
                    <div style="width: 2%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.currentEmergencyResponse?.isHazmat ? "X" : " "
                    }</div>
                    <div style="width: 8%;"></div>
                    <div style="width: 15%; font-weight: bold; padding-top: 5px;">Odor</div>
                    <div style="width: 2%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.currentEmergencyResponse?.isOdor ? "X" : " "
                    }</div>
                    <div style="width: 8%;"></div>
                </div>

                <div style="display: flex; margin-bottom: 10px;">
                    <div style="width: 15%; font-weight: bold; padding-top: 5px;">Fire</div>
                    <div style="width: 2%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.currentEmergencyResponse?.isFire ? "X" : " "
                    }</div>
                    <div style="width: 8%;"></div>
                    <div style="width: 15%; font-weight: bold; padding-top: 5px;">Medical</div>
                    <div style="width: 2%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.currentEmergencyResponse?.isMedical ? "X" : " "
                    }</div>
                    <div style="width: 8%;"></div>
                    <div style="width: 15%; font-weight: bold; padding-top: 5px;">ERT Callout</div>
                    <div style="width: 2%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.currentEmergencyResponse?.isERTCallOut ? "X" : " "
                    }</div>
                    <div style="width: 8%;"></div>
                    <div style="width: 15%; font-weight: bold;"></div>
                    <div style="width: 2%; padding: 5px;"></div>
                    <div style="width: 8%;"></div>
                </div>

                <div style="display: flex; margin-bottom: 10px;">
                    <div style="width: 15%; font-weight: bold; padding-top: 5px;">Other</div>
                    <div style="width: 2%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.currentEmergencyResponse?.isOther ? "X" : ""
                    }</div>
                    <div style="width: 8%;"></div>
                    <div style="width: 15%; font-weight: bold; padding-top: 5px;">Other Desc</div>
                    <div style="width: 60%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.currentEmergencyResponse?.otherDescription ?? ""
                    }</div>
                    <div></div><div></div><div></div><div></div><div></div><div></div><div></div>

                </div>

                <div style="display: flex; margin-bottom: 10px;">
                    <div style="width: 17%; font-weight: bold; padding-top: 5px;">Short Description</div>
                    <div style="width: 83%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.currentEmergencyResponse?.description ?? ""
                    }</div>
                </div>

                <div style="text-align: center; background-color: #d3d3d3; padding: 5px; margin-top: 10px;">Reason for Response</div>
                <div style="border: 1px solid black; padding: 5px; margin-bottom: 10px;">&nbsp;${
                  this.currentEmergencyResponse?.reasonForResponse ?? " "
                }</div>

                <div style="text-align: center; background-color: #d3d3d3; padding: 5px;">Tactics</div>
                <div style="border: 1px solid black; padding: 5px; margin-bottom: 10px;">&nbsp;${
                  this.currentEmergencyResponse?.tactics ?? " "
                }</div>

                <div style="text-align: center; background-color: #d3d3d3; padding: 5px;">Results</div>
                <div style="border: 1px solid black; padding: 5px; margin-bottom: 10px;">&nbsp;${
                  this.currentEmergencyResponse?.results ?? " "
                }</div>

                <div style="text-align: center; background-color: #d3d3d3; padding: 5px;">Comments</div>
                <div style="border: 1px solid black; padding: 5px; margin-bottom: 20px;">&nbsp;${
                  this.currentEmergencyResponse?.comments ?? " "
                }</div>
            </div>
        </div>
    </main>
    <script>
        window.onload = function() {
            window.print();
        }
    </script>
</body>

</html>
        `
        );
        printWindow.document.close();
      } else {
        console.error("Could not open print window");
      }
    });
  }
}
